import { FC } from "react";
import styles from "./discount-badge.module.css";

interface DiscountBadgeProps {
  className?: string;
  percentageDiscount: number;
}

const DiscountBadge: FC<DiscountBadgeProps> = ({
  className,
  percentageDiscount
}) => {
  return (
    <div className={`${styles.discountBadgeWrapper} ${className}`}>
      {percentageDiscount}%
    </div>);

};

export default DiscountBadge;